<template>
  <div class="breadcrumb">
    <div class="breadcrumb-item" v-for="(item, index) in route.matched" :key="index">
      <template v-if="item.meta.title">
        <!-- 最后一个是蓝色，不能点击 -->
        <router-link v-if="index < route.matched.length - 1" :to="item.path">
          {{ item.meta.title }}
        </router-link>
        <span v-else class="blue">{{ item.meta.title }}</span>
        <!-- 最后一个不显示 -->
        <img v-if="index < route.matched.length - 1" src="@/assets/images/menu/right.png" alt="" />
      </template>
    </div>
  </div>
</template>
<script setup>
const route = useRoute()
console.log(route.matched)
</script>
<style lang="scss" scoped>
.breadcrumb {
  height: 100%;
  display: flex;
  align-items: center;
  .breadcrumb-item {
    display: flex;
    align-items: center;
    img {
      width: 5px;
      height: 8.33px;
      margin: 0 8px;
    }
    a {
      font-size: 18px;
      font-weight: bold;
      color: #0a1629;
      &:hover {
        // 蓝色
        color: #409eff;
      }
    }
    .blue {
      font-size: 18px;
      font-weight: bold;
      color: #409eff;
    }
  }
}
</style>
